document.addEventListener('DOMContentLoaded', function() {
  const mapDiv = document.getElementById('map');
  const sliderTrack = document.getElementById('sakura-status-track');
  const guideMsg = document.getElementById('sakura-guide-msg');
  if (!mapDiv) return;

  // --- 🌙 1. 日本時間での夜間判定 ---
  const now = new Date();
  const hour = now.getHours();
  const isNight = (hour >= 20 || hour < 5);


  // --- 2. 地図初期化（スマホ操作優先設定） ---
  const initialZoom = window.innerWidth < 768 ? 4.5 : 5.2;
  const map = L.map('map', {
    dragging: false, scrollWheelZoom: false, touchZoom: false,
    doubleClickZoom: false, zoomControl: false, tap: false
  }).setView([37.5, 138.0], initialZoom);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

  if (isNight) {
    const tilePane = map.getPane('tilePane');
    if (tilePane) {
      tilePane.style.filter = 'invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%)';
    }
    mapDiv.style.background = '#222';
  }

  const frontLine = document.getElementById('physical-sakura-line');

  // ガイドメッセージ消去ロジック
  function hideGuide() {
    if (guideMsg && guideMsg.style.display !== 'none') {
      guideMsg.style.opacity = '0';
      guideMsg.style.transform = 'translateY(-10px)';
      setTimeout(() => { guideMsg.style.display = 'none'; }, 500);
    }
  }

  // --- 3. 描画ロジック（ハイブリッド・アイコン仕様） ---
  function render(data) {
    const today = new Date();
    let latestLat = 32.5;
    if (sliderTrack) sliderTrack.innerHTML = '';
    map.eachLayer((layer) => { if (layer instanceof L.Marker) map.removeLayer(layer); });

    const ICON_URLS = {
      tsubomi: "https://fonts.gstatic.com/s/e/notoemoji/latest/1f331/512.gif",
      kaika: "https://fonts.gstatic.com/s/e/notoemoji/latest/1f338/512.gif",
      mankai: "https://raw.githubusercontent.com/googlefonts/noto-emoji/main/png/512/emoji_u1f33a.png", // 安定のPNG
      fubuki: "https://fonts.gstatic.com/s/e/notoemoji/latest/1f343/512.gif"
    };

    data.sort((a,b) => new Date(a.openDate) - new Date(b.openDate)).forEach(city => {
      const open = new Date(city.openDate), full = new Date(city.fullDate);
      const end = new Date(full.getTime() + 7*24*60*60*1000);
      
      let imgUrl = ICON_URLS.tsubomi, status = "つぼみ", cardClass = "future";
      if (today >= open && today < full) { imgUrl = ICON_URLS.kaika; status = "開花中！"; cardClass = "open"; }
      else if (today >= full && today < end) { imgUrl = ICON_URLS.mankai; status = "満開✨"; cardClass = "full"; }
      else if (today >= end) { imgUrl = ICON_URLS.fubuki; status = "桜吹雪"; cardClass = "end"; }

      // 特殊な桜の注釈（復活！）
      let typeNote = "";
      if(city.type === "hikan") typeNote = '<div style="font-size:9px; color:#ff1493;">※ヒカンザクラ</div>';
      if(city.type === "ezo") typeNote = '<div style="font-size:9px; color:#db7093;">※エゾヤマザクラ</div>';

      // マーカー設定
      const markerGlow = isNight ? 'filter: drop-shadow(0 0 5px white);' : (city.isOfficial ? 'filter: drop-shadow(0 0 5px #ff4f5e);' : '');
      const markerIcon = L.divIcon({ 
        html: `<img src="${imgUrl}" style="width:40px; height:40px; ${markerGlow}">`, 
        className: '',
        iconSize: [40, 40],
        iconAnchor: [20, 20]
      });

      // ポップアップ（速報バッジ復活！）
      L.marker([city.lat, city.lng], { icon: markerIcon }).addTo(map)
        .bindPopup(`<b>${city.city}</b>: ${status}${city.isOfficial ? ' <span style="color:red;font-size:10px;">速報</span>' : ''}${typeNote}`);

      // スライダーカード（注釈復活！）
      if (sliderTrack) {
        const card = document.createElement('div');
        card.className = `sakura-status-card ${cardClass} ${city.isOfficial ? 'official-card' : ''}`;
        if(cardClass === "open" || cardClass === "full") {
          card.style.background = "linear-gradient(145deg, #fff0f3, #ffffff)";
          card.style.border = "1px solid #ffb7c5";
        }
        card.innerHTML = `
          <div class="card-icon"><img src="${imgUrl}" style="width:32px; height:32px;"></div>
          <div class="card-city">${city.city}${city.isOfficial ? '🌸' : ''}</div>
          <div class="card-status">${status}</div>
          <div class="card-dates">${city.openDate.substring(5).replace('-','/')}〜</div>
          ${typeNote}`;
        sliderTrack.appendChild(card);
      }
      if (!city.type && (status.includes("開花") || status.includes("満開")) && city.lat > latestLat) { latestLat = city.lat; }
    });
    startAnimation(latestLat);
  }

  async function fetchSakuraData() {
    const gasUrl = "https://script.google.com/macros/s/AKfycbxWPRKqkWNVB62RqbVAG1T9layDRhXrP4OwPPTtg5o3nsPh7qG4LRrx_FhfwnITDLnq/exec";
    let sakuraData = JSON.parse(mapDiv.dataset.sakuraInfo || "[]");
    hideGuide(); 
    try {
      const res = await fetch(gasUrl);
      const officialData = await res.json();
      if (Array.isArray(officialData)) {
        sakuraData = sakuraData.map(tempCity => {
          const official = officialData.find(o => o.city === tempCity.city);
          if (official) return { ...tempCity, openDate: official.openDate, fullDate: official.fullDate, isOfficial: true };
          return tempCity;
        });
      }
    } catch (e) { console.warn("GAS失敗"); }
    render(sakuraData);
  }

  function startAnimation(targetLat) {
    function animate() {
      const drift = Math.sin(Date.now() / 1500) * 0.12;
      const p = map.latLngToContainerPoint([targetLat + drift, 138]);
      if (frontLine && p.y > 0 && p.y < mapDiv.offsetHeight) {
        frontLine.style.display = 'block'; frontLine.style.top = p.y + 'px';
      }
      requestAnimationFrame(animate);
    }
    animate();
  }

  fetchSakuraData();
  setTimeout(() => { map.invalidateSize(); }, 500);

  if (sliderTrack) {
    let isDown = false, startX, scrollLeft;
    sliderTrack.addEventListener('mousedown', (e) => { isDown = true; startX = e.pageX - sliderTrack.offsetLeft; scrollLeft = sliderTrack.scrollLeft; });
    sliderTrack.addEventListener('mouseleave', () => { isDown = false; });
    sliderTrack.addEventListener('mouseup', () => { isDown = false; });
    sliderTrack.addEventListener('mousemove', (e) => { if(!isDown) return; e.preventDefault(); const x = e.pageX - sliderTrack.offsetLeft; const walk = (x - startX) * 2; sliderTrack.scrollLeft = scrollLeft - walk; });
  }

  // 位置情報関数（復活！）
  window.triggerGeolocation = function() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => { console.log("位置情報受信"); },
        (err) => console.warn(err),
        { timeout: 8000 }
      );
    }
  };
});